export default function ContactSection() {
  const contacts = [
    { icon: "ri-telegram-line", label: "Telegram", value: "@dmitrievvvaaa", href: "https://t.me/dmitrievvvaaa" },
    { icon: "ri-time-line", label: "Режим работы", value: "Пн–Пт, 9:00–18:00 МСК" },
  ];

  return (
    <section id="contact" className="relative py-24 lg:py-32 overflow-hidden bg-background-100">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold tracking-widest uppercase mb-4 bg-primary-100 text-primary-700">
            Контакты
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground-950 mb-5">
            Хотите стать оператором чата?{" "}
            <span className="text-primary-500">Свяжитесь с нами</span>
          </h2>
          <p className="text-foreground-600 text-base lg:text-lg max-w-2xl mx-auto leading-relaxed">
            Напишите нам в Telegram — ответим на все вопросы по вакансии и расскажем, как начать.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 max-w-4xl mx-auto">
          <div className="rounded-2xl p-7 bg-background-50 border border-primary-100 shadow-sm">
            <h3 className="text-foreground-950 font-semibold text-xl mb-6">Контакты отдела кадров</h3>
            <div className="flex flex-col gap-5">
              {contacts.map((c) => (
                <div key={c.label} className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-50 flex-shrink-0">
                    <i className={`${c.icon} text-primary-500 text-lg`} />
                  </div>
                  <div>
                    <div className="text-foreground-500 text-xs mb-0.5">{c.label}</div>
                    {c.href ? (
                      <a
                        href={c.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-foreground-950 text-sm font-medium hover:text-primary-500 transition-colors"
                      >
                        {c.value}
                      </a>
                    ) : (
                      <div className="text-foreground-950 text-sm font-medium">{c.value}</div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-2xl p-7 lg:p-8 bg-primary-500 flex flex-col justify-center gap-4">
            <p className="text-background-50 font-semibold text-xl mb-1">Готовы начать?</p>
            <p className="text-background-100 text-sm leading-relaxed mb-2">
              Напишите HR-менеджеру в Telegram — ответим в рабочее время, расскажем об обучении и первой смене.
            </p>
            <a
              href="https://t.me/dmitrievvvaaa"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 w-full py-3.5 rounded-xl font-semibold text-primary-600 bg-background-50 hover:bg-background-100 transition-colors duration-200 cursor-pointer whitespace-nowrap text-base"
            >
              <i className="ri-telegram-line text-lg" />
              Написать в Telegram
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
